import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputAdornment from '@material-ui/core/InputAdornment';

import CloseIcon from '@material-ui/icons/Close';

import Loading from 'app/components/loaders/Loading';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

const initValues = {
    amount: 0.00,
    use_card: true
}

export default function BatchRefundDialog(props) {

    const { ids, open, onClose, onClosed, onSave } = props;

    const [ values, setValues ] = useState(initValues);

    const [ errors, setErrors ] = useState({});
    const [ loading, setLoading ] = useState(false);

    const classes = useStyles();
    const api = useApi();

    // Setter Functions -----------------------------------------------

    const handleChange = name => e => {

        const target = e.target;
        const value = (target.type === 'checkbox' ? target.checked : target.value);

        if (isError(name)) delete errors[name];

        setValues({ ...values, [name]: value });
    };

    // Post Functions -----------------------------------------------

    const postBatchRefund = () => {
        setLoading(true);

        api.post('/admin/accounting/refund/batch', {...values, invoice_ids: ids})
            .then(res => onSave())
            .catch(error => {
                setLoading(false);

                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
            }).then(() => onSave());
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    }

    const onExited = () => {
        setValues(initValues);
        setLoading(false);

        if (onClosed) onClosed();
    }

    return (
        <Dialog
            aria-labelledby="batch-refund-dialog-title"
            open={open}
            aria-describedby="batch-refund-dialogue-description"
            fullWidth
            maxWidth="xs"
            onClose={onClose}
            onExited={onExited}
            >
            <Loading isLoading={loading}/>
            <DialogTitle id="batch-refund-dialog-title">
                Batch Refund
                <IconButton
                    aria-label="Cancel"
                    className={classes.closeButton}
                    onClick={onClose}
                    disabled={loading}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <form>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Amount"
                        variant="outlined"
                        value={values.amount}
                        onChange={handleChange('amount')}
                        error={isError('amount')}
                        helperText={getErrorMessage('amount')}
                        type="number"
                        min={0}
                        step={0.01}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                    />
                    <FormControlLabel
                        margin="normal"
                        control={
                            <Switch
                                checked={values.use_card}
                                onChange={handleChange('use_card')}
                                color="primary"
                            />
                        }
                        label="Refund to credit/debit card if available?"
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    onClick={postBatchRefund}
                    color="primary"
                    variant="contained"
                    >
                    Refund
                </Button>
            </DialogActions>
        </Dialog>
    );
}
